import React, { useState } from 'react';
import { Lock, Eye, EyeOff, AlertCircle, CheckCircle } from 'lucide-react';
import supabase from '../../services/supabaseClient';
import { produtoDaUrl } from '../../config/produtoDaUrl';

const ResetPasswordPage = ({ onConcluido }) => {
  const [senha, setSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');

    if (senha.length < 6)       { setErro('A senha deve ter no mínimo 6 caracteres'); return; }
    if (senha !== confirmar)     { setErro('As senhas não coincidem'); return; }

    setCarregando(true);
    try {
      const { error } = await supabase.auth.updateUser({ password: senha });
      if (error) throw error;

      setSucesso(true);
      await supabase.auth.signOut();
      setTimeout(() => onConcluido(), 3000);
    } catch (err) {
      setErro(err.message || 'Erro ao redefinir a senha');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-100 to-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">

        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img src="/integrai-marca.png" alt="IntegrAI" className="w-28 h-auto" />
          </div>
          <h1 className="text-[28px] font-medium mb-1"><span className="text-blue-800">IntegrAI</span><span className="text-blue-400">CRM</span></h1>
          <p className="text-slate-500">Redefinição de senha</p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8">

          {sucesso ? (
            <div className="text-center py-4">
              <CheckCircle className="w-14 h-14 text-green-500 mx-auto mb-4" />
              <h3 className="text-slate-900 font-semibold text-lg mb-2">Senha redefinida!</h3>
              <p className="text-slate-500 text-sm">Redirecionando para o login...</p>
            </div>
          ) : (
            <>
              <h3 className="text-slate-900 font-semibold text-lg mb-1">Nova senha</h3>
              <p className="text-slate-500 text-sm mb-6">Digite e confirme sua nova senha abaixo.</p>

              {erro && (
                <div className="mb-5 p-4 bg-red-50 border border-red-100 rounded-lg flex items-start gap-3">
                  <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-red-700">{erro}</p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-2">Nova senha</label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500" />
                    <input
                      type={mostrarSenha ? 'text' : 'password'}
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                      placeholder="Mínimo 6 caracteres"
                      autoComplete="new-password"
                      className="w-full pl-11 pr-12 py-3 bg-white border border-slate-300 rounded-lg text-slate-800 placeholder-slate-400 focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-400/30"
                    />
                    <button
                      type="button"
                      onClick={() => setMostrarSenha(!mostrarSenha)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                    >
                      {mostrarSenha ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-2">Confirmar nova senha</label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500" />
                    <input
                      type={mostrarSenha ? 'text' : 'password'}
                      value={confirmar}
                      onChange={(e) => setConfirmar(e.target.value)}
                      placeholder="Digite a senha novamente"
                      autoComplete="new-password"
                      className="w-full pl-11 pr-4 py-3 bg-white border border-slate-300 rounded-lg text-slate-800 placeholder-slate-400 focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-400/30"
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={carregando}
                  className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-200 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-lg transition-all flex items-center justify-center gap-2"
                >
                  {carregando
                    ? <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
                    : 'Redefinir senha'
                  }
                </button>
              </form>
            </>
          )}
        </div>

        <div className="text-center mt-6">
          <p className="text-sm text-slate-400">{produtoDaUrl().nome} © {new Date().getFullYear()} — Todos os direitos reservados</p>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
